import { useTheme } from "../../context/ThemeContext"
import ReactSelect from 'react-select';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useMemo, useState, useRef, useEffect } from "react";
import JoditEditor from "jodit-react";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
// import TimePicker from 'rc-time-picker';
// import 'rc-time-picker/assets/index.css';

function getSelectFieldValue(field) {
  if (field == null || field === "") return "";
  if (typeof field === "object" && field.value != null) return field.value;
  return field;
}

export const HiddenInput = ({ fields, setFields, column, value = '', errors = {}, disabled = false }) => {
  return (
    <>
      <input 
        type="hidden" 
        id={column} 
        value={fields[column] || value} 
        disabled={disabled} 
        onChange={(e) => {
          setFields((prev) => ({ ...prev, [column]: e.target.value }));
        }} 
      />
      
      {/* Error message for the hidden field if needed */}
      {errors[column] && <div className="text-danger d-none">{errors[column]}</div>}
    </>
  );
};


export const Text = ({fields, setFields, column, label = null, required = false, errors = {}, validator = null, rules = '', disabled = false}) => {
  const validatorKey = label.replace(/ /g, "_");
    return <>
            <label htmlFor={column} className="form-label">{label}
              {required ? <span className="text-danger"> *</span> : ''}
            </label>

            <input type="text" className="form-control" id={column} placeholder={label} value={fields[column]}
              required={required} disabled={disabled} onChange={(e) => {
                setFields((prev) => ({ ...prev, [column]: e.target.value })); validator?.current.showMessageFor(validatorKey);
              }}
              // onBlur={() => validator?.current.showMessageFor(column)}
              />

            {validator?.current.message(validatorKey, fields[column], rules, { className: 'text-danger' }) ||
              errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

export const TextNumber = ({fields, setFields, column, label = null, required = false, errors = {}, validator = null, rules = '', disabled = false}) => {
  const validatorKey = label.replace(/ /g, "_");
  const keys = ["Backspace",  "Delete", "ArrowLeft", "ArrowRight", "Tab", "-"];

  const handleNumericKeyDown = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (keys.includes(e.key)) return;
    if (/\d/.test(e.key)) return;
    e.preventDefault();
  };

    return <>
            <label htmlFor={column} className="form-label">{label}
              {required ? <span className="text-danger"> *</span> : ''}
            </label>
                
            <input type="text" className="form-control" id={column} placeholder={label} value={fields[column]} autoComplete="off"
              onKeyDown={handleNumericKeyDown}
              required={required} disabled={disabled} onChange={(e) => {
                setFields((prev) => ({ ...prev, [column]: e.target.value })); validator?.current.showMessageFor(validatorKey);
              }} />

            {validator?.current.message(validatorKey, fields[column], rules, { className: 'text-danger' }) ||
              errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

export const TextFloat = ({fields, setFields, column, label, required = false, errors = {}, validator = null, rules = '', disabled = false}) => {
  const validatorKey = label.replace(/ /g, "_");
  const keys = ["Backspace",  "Delete", "ArrowLeft", "ArrowRight", "Tab", "-", "."];

  const handleFloatKeyDown = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (keys.includes(e.key)) return;
    if (/\d/.test(e.key)) return;
    e.preventDefault();
  };

    return <>
            <label htmlFor={column} className="form-label">{label}
              {required ? <span className="text-danger"> *</span> : ''}
            </label>
                
            <input type="text" className="form-control" id={column} placeholder={label} value={fields[column]} autoComplete="off"
              onKeyDown={handleFloatKeyDown}
              required={required} disabled={disabled} onChange={(e) => {
                setFields((prev) => ({ ...prev, [column]: e.target.value })); validator?.current.showMessageFor(validatorKey);
              }} />

            {validator?.current.message(validatorKey, fields[column], rules, { className: 'text-danger' }) ||
              errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

export const TextEmail = ({fields, setFields, column, label, required = false, errors = {}, validator = null, rules = '', disabled=false}) => {
  const validatorKey = label.replace(/ /g, "_");

    return <>
            <label htmlFor={column} className="form-label">{label}
              {required ? <span className="text-danger"> *</span> : ''}
            </label>
                
            <input type="email" className="form-control" id={column} placeholder={label} value={fields[column]}
              required={required} disabled={disabled} onChange={(e) => {
                setFields((prev) => ({ ...prev, [column]: e.target.value })); validator?.current.showMessageFor(validatorKey);
              }} />

            {validator?.current.message(validatorKey, fields[column], rules, { className: 'text-danger' }) ||
              errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

export const TextPassword = ({isEdit = false, fields, setFields, column, label, required = false, errors = {}}) => {

  let help = '';
  if (isEdit === true) {
    required = false;
    help = "You can leave Password blank, if you don't want to change";
  }

  let toggleFlag = column + '_toggle';
  
  return <>
        <label htmlFor={column} className="form-label">{label}
          {required ? <span className="text-danger"> *</span> : ''}
        </label>

        <div className="input-group">
          <input type={(fields[toggleFlag] ?? false) ? 'text' : 'password'} className="form-control" id={column} placeholder={label}
            required={required} onChange={(e) => setFields((prev) => ({ ...prev, [column]: e.target.value }))} />
          <button type="button" className="input-btn btn btn-light" onClick={(e) => setFields((prev) => ({ ...prev, [toggleFlag]: (fields[toggleFlag] ?? false) ? false : true }))}>
            <i className={'bi bi-eye'+ ((fields[toggleFlag] ?? false) ? '-slash' : '') +' align-middle'}></i>
          </button>
        </div>

        {errors[column] && <div className="text-danger">{errors[column]}</div>}
        {help && <p><small>{help}</small></p>}
    </>
}

export const TextArea = ({fields, setFields, column, label, required = false, errors = {}, disabled=false}) => {
    return <>
            <label htmlFor={column} className="form-label">{label}
              {required ? <span className="text-danger"> *</span> : ''}
              
            </label>

            <textarea type="text" disabled={disabled} className="form-control" id={column} placeholder={label} required={required}
              onChange={(e) => setFields((prev) => ({ ...prev, [column]: e.target.value }))} value={fields[column]}>
            </textarea>

            {errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

// export const MyReactSelect = ({options, fields, setFields, column, label = null, required = false, errors = {}, disabled = false, firstOption = true, quickAddKey = null, quickAddSet = null, onChange = null}) => {
//   const handleChange = (selectedOption) => {
//     const newValue = selectedOption ? selectedOption.value : ""; // Get the value from selected option object
//     setFields((prev) => ({ ...prev, [column]: newValue }));

//     if (onChange) {
//       onChange(selectedOption); // Call the custom onChange with the full selected option
//     }
//   };
//   const { theme, toggleTheme, selectBoxTheme } = useTheme();

//   let placeholder = '';
//   let noOptionsMessage = 'Nothing found!';
//   if (label) {
//     noOptionsMessage = `No ${label.toLowerCase()} found!`;
//   }

//   if (label && firstOption === true) {
//     placeholder = `Select ${label.toLowerCase()}`;
//   } else if (firstOption) {
//     placeholder = firstOption;
//   }

//   if (quickAddKey) {
//     noOptionsMessage = <div>{noOptionsMessage}  <button className="btn btn-info btn-sm" type="button" onClick={() => quickAddSet((prev) => ({ ...prev, [quickAddKey]: true }) )}><i className="bx bx-plus"></i> New</button></div>
//   }

//    return <>
//           {label && <label htmlFor={column} className="form-label">{label}
//             {required ? <span className="text-danger"> *</span> : ''}
//           </label>}

//             <ReactSelect
//               value={fields[column]}
//               //onChange={(e) => setFields((prev) => ({ ...prev, [column]: e }))}
//               onChange={handleChange}
//               options={options}
//               placeholder={placeholder}
//               isClearable={true}
//               isSearchable="true"
//               noOptionsMessage={() => noOptionsMessage}
//               styles={selectBoxTheme}
//               isDisabled={disabled}
//               // theme={(selectBoxTheme) => ({
//               //   ...selectBoxTheme,
//               //   borderRadius: 0,
//               // })}
//             />
//           {errors[column] && <div className="text-danger">{errors[column]}</div>}
//         </>
// }
export const MyReactSelect = ({
  options,
  fields,
  setFields,
  column,
  label = null,
  required = false,
  errors = {},
  disabled = false,
  firstOption = true,
  quickAddKey = null,
  quickAddSet = null,
  onChange = null,
  validator = null,
  rules = "",
}) => {
  const validatorKey = label ? label.replace(/ /g, "_") : column;

  const handleChange = (selectedOption) => {
    setFields((prev) => ({ ...prev, [column]: selectedOption }));
    validator?.current.showMessageFor(validatorKey);

    if (onChange) {
      onChange(selectedOption);
    }
  };

  const { theme, selectBoxTheme } = useTheme();

  let placeholder = '';
  let noOptionsMessage = 'Nothing found!';
  if (label) {
    noOptionsMessage = `No ${label.toLowerCase()} found!`;
  }

  if (label && firstOption === true) {
    placeholder = `Select ${label.toLowerCase()}`;
  } else if (firstOption) {
    placeholder = firstOption;
  }

  if (quickAddKey) {
    noOptionsMessage = (
      <div>
        {noOptionsMessage}
        <button
          className="btn btn-info btn-sm"
          type="button"
          onClick={() =>
            quickAddSet((prev) => ({ ...prev, [quickAddKey]: true }))
          }
        >
          <i className="bx bx-plus"></i> New
        </button>
      </div>
    );
  }

  return (
    <>
      {label && (
        <label htmlFor={column} className="form-label">
          {label}
          {required ? <span className="text-danger"> *</span> : ''}
        </label>
      )}

      <ReactSelect
        value={fields[column]} // Set value as the full object
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        isClearable={true}
        isSearchable={true}
        noOptionsMessage={() => noOptionsMessage}
        styles={selectBoxTheme}
        isDisabled={disabled}
      />

      {validator?.current.message(
        validatorKey,
        getSelectFieldValue(fields[column]),
        rules,
        { className: "text-danger" }
      )}

      {errors[column] && <div className="text-danger">{errors[column]}</div>}
    </>
  );
};
export const MyReactSelectMultiple = ({options, fields, setFields, column, label, required = false, errors = {}, disabled = false, validator = null, rules = '', quickAddKey = null, quickAddSet = null, firstOption = true}) => {
  
  const { theme, toggleTheme, selectBoxTheme } = useTheme();
  const validatorKey = validator ? label.replace(/ /g, "_") : '';

  let placeholder = '';
  let noOptionsMessage = 'Nothing found!';
  if (label) {
    noOptionsMessage = `No ${label.toLowerCase()} found!`;
  }

  if (label && firstOption === true) {
    placeholder = `Select ${label.toLowerCase()}`;
  } else if (firstOption) {
    placeholder = firstOption;
  }

  if (quickAddKey) {
    noOptionsMessage = <div>{noOptionsMessage}  <button className="btn btn-info btn-sm" type="button" onClick={() => quickAddSet((prev) => ({ ...prev, [quickAddKey]: true }) )}><i className="bx bx-plus"></i> New</button></div>
  }

  return <>
          <label htmlFor={column} className="form-label">{label}
            {required ? <span className="text-danger"> *</span> : ''}
          </label>

          <ReactSelect
            value={fields[column]}
            onChange={(e) => { setFields((prev) => ({ ...prev, [column]: e })); validator?.current.showMessageFor(validatorKey); }}
            options={options}
            placeholder={placeholder}
            isSearchable="true"
            noOptionsMessage={() => noOptionsMessage}
            styles={selectBoxTheme}
            isDisabled={disabled}
            isMulti={true}
            openIsOpen={true}
            // theme={(selectBoxTheme) => ({
            //   ...selectBoxTheme,
            //   borderRadius: 0,
            // })}
          />

          {validator?.current.message(validatorKey, fields[column], rules, { className: 'text-danger' }) ||
            errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

export const MySelect = ({options, fields, setFields, column, label = null, required = false, errors = {}, firstOption = true, onChange = null, disabled = false, validator = null, rules = ''}) => {
  const validatorKey = label ? label.replace(/ /g, "_") : column;

  const handleChange = (e) => {
    const newValue = e.target.value;
    setFields((prev) => ({ ...prev, [column]: newValue }));
    validator?.current.showMessageFor(validatorKey);

    if (onChange) {
      onChange(newValue);
    }
  };
  return <>
    {label &&
    <label htmlFor={column} className="form-label">{label}
      {required ? <span className="text-danger"> *</span> : ''}
    </label>}

    <select name={column} id={column} required={required} disabled={disabled} className="form-control cms-native-select"
      onChange={handleChange}
      value={fields[column] ?? ''}>
      {firstOption === true ? <option value="">Select {label?.toLowerCase()}</option> : ''}
      {firstOption && firstOption !== true ? <option value="">{firstOption}</option> : ''}
      {options?.map(val => <option key={val.value} value={val.value}>{val.label}</option>)}
    </select>

    {validator?.current.message(validatorKey, fields[column] ?? '', rules, { className: 'text-danger' })}

    {errors[column] && <div className="text-danger">{errors[column]}</div>}
  </>
}

export const DatePicker = ({fields, setFields, column, label = null, required = false, errors = {}, pluginProps = {}, disabled = false, showMonthYearOnly = false }) => {
  let years = [];
  const maxYear = (new Date()).getFullYear() + 20;
  for (let year = 1950; year <= maxYear; year++) {
    years.push(year);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return <>
          <label htmlFor={column} className="form-label">{label}
            {required ? <span className="text-danger"> *</span> : ''}
          </label>

          <ReactDatePicker 
            {...pluginProps}
            disabled={disabled}
            popperPlacement="bottom-start"
            popperProps={{
              strategy: "fixed",
            }}
            popperModifiers={[
              {
                name: "offset",
                options: {
                  offset: [0, 8],
                },
              },
              {
                name: "preventOverflow",
                options: {
                  rootBoundary: "viewport",
                  tether: false,
                  altAxis: true,
                },
              },
            ]}
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
              }) => (
              <div style={{margin: 5, display: "flex", justifyContent: "center"}}>
                <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="react-datepicker__navigation react-datepicker__navigation--previous">
                  <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">Previous</span>
                </button>
      
                <select className="date-dropdown year" value={months[date.getMonth()]} onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }>
                  {months.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
                <select className="date-dropdown month" value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
                  {years.map((option) => ( <option key={option} value={option}>{option}</option> ))}
                </select>
      
                <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="react-datepicker__navigation react-datepicker__navigation--next">
                  <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">Next</span>
                </button>
              </div>
            )}
            className="form-control" placeholderText={showMonthYearOnly ? "MM-YYYY" : "DD-MM-YYYY"} id={column} autoComplete="off" required={required}
            selected={fields[column] instanceof Date && !isNaN(fields[column]) ? fields[column] : null}
            onSelect={(e) => setFields((prev) => ({ ...prev, [column]: e }))}
            onChange={(e) => setFields((prev) => ({ ...prev, [column]: e }))}
            dateFormat={showMonthYearOnly ? "MM-yyyy" : "dd-MM-yyyy"}
            showMonthYearPicker={showMonthYearOnly} />

          {errors[column] && <div className="text-danger">{errors[column]}</div>}
        </>
}

export const MyTimePicker = ({
  fields,
  setFields,
  column,
  label = null,
  required = false,
  errors = {},
  disabled = false,
  minTime = null,
  maxTime = null,
  onChange = null,
}) => {
  const toMinutes = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
      return value.getHours() * 60 + value.getMinutes();
    }
    if (typeof value === "string") {
      const match24 = value.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
      if (match24) {
        return Number(match24[1]) * 60 + Number(match24[2]);
      }
      const match12 = value
        .trim()
        .match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(am|pm)$/i);
      if (match12) {
        let hours = Number(match12[1]);
        const minutes = Number(match12[2]);
        const meridiem = match12[3].toLowerCase();
        if (meridiem === "pm" && hours < 12) hours += 12;
        if (meridiem === "am" && hours === 12) hours = 0;
        return hours * 60 + minutes;
      }
    }
    const parsed = new Date(Date.parse(`2024-01-01 ${value}`));
    if (isNaN(parsed)) return null;
    return parsed.getHours() * 60 + parsed.getMinutes();
  };

  const hmsToMinutes = (hms) => {
    if (!hms || typeof hms !== "string") return null;
    const parts = hms.split(":");
    if (parts.length < 2) return null;
    const hours = Number(parts[0]);
    const minutes = Number(parts[1]);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return hours * 60 + minutes;
  };

  const isWithinBounds = (value) => {
    const mins = toMinutes(value);
    if (mins === null) return true;
    const minMins = hmsToMinutes(minTime);
    const maxMins = hmsToMinutes(maxTime);
    if (minMins !== null && mins < minMins) return false;
    if (maxMins !== null && mins > maxMins) return false;
    return true;
  };

  const [pickerKey, setPickerKey] = useState(0);

  const handleChange = (value) => {
    if (value && !isWithinBounds(value)) {
      // Remount so the UI resets to the last valid controlled value
      setPickerKey((k) => k + 1);
      return;
    }
    if (typeof onChange === "function") {
      onChange(value);
      return;
    }
    setFields((prev) => ({ ...prev, [column]: value }));
  };

  let pickerValue = fields[column] || null;
  if (pickerValue instanceof Date && !isNaN(pickerValue)) {
    const hours = String(pickerValue.getHours()).padStart(2, "0");
    const minutes = String(pickerValue.getMinutes()).padStart(2, "0");
    pickerValue = `${hours}:${minutes}:00`;
  }

  return (
    <>
      <label htmlFor={column} className="form-label">
        {label}
        {required ? <span className="text-danger"> *</span> : ""}
      </label>

      <TimePicker
        key={`${column}-${pickerKey}-${minTime || ""}-${maxTime || ""}`}
        className="form-control"
        clearIcon=""
        disableClock={true}
        disabled={disabled}
        format="h:mm a"
        minuteAriaLabel="Minute"
        hourAriaLabel="Hour"
        amPmAriaLabel="AM/PM"
        minTime={minTime || undefined}
        maxTime={maxTime || undefined}
        value={pickerValue}
        onChange={handleChange}
      />

      {errors[column] && <div className="text-danger">{errors[column]}</div>}
    </>
  );
};

export const Editor = ({
  fields,
  setFields,
  column,
  label = null,
  required = false,
  errors = {},
  height = 300,
  editorRef = null,
  disabled = false,
  simpleToolbar = false,
}) => {
  const latestValueRef = useRef(fields[column] || "");

  useEffect(() => {
    latestValueRef.current = fields[column] || "";
  }, [fields, column]);

  const editorConfig = useMemo(
    () => ({
      readonly: disabled,
      height,
      placeholder: label ? `Enter ${label}...` : "Enter text...",
      toolbarButtonSize: "small",
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      ...(simpleToolbar
        ? {
            buttons: [
              "bold",
              "italic",
              "underline",
              "|",
              "ul",
              "ol",
              "|",
              "outdent",
              "indent",
              "|",
              "undo",
              "redo",
              "|",
              "eraser",
            ],
            buttonsMD: [
              "bold",
              "italic",
              "underline",
              "|",
              "ul",
              "ol",
              "|",
              "undo",
              "redo",
            ],
            buttonsSM: ["bold", "italic", "|", "ul", "ol"],
            buttonsXS: ["bold", "ul", "ol"],
          }
        : {}),
    }),
    [label, height, disabled, simpleToolbar]
  );

  const commitValue = (value) => {
    const next = value ?? "";
    latestValueRef.current = next;
    setFields((prev) => {
      if (prev[column] === next) return prev;
      return { ...prev, [column]: next };
    });
  };

  return (
    <>
      <label htmlFor={column} className="form-label">
        {label}
        {required ? <span className="text-danger"> *</span> : ""}
      </label>

      <div data-editor-column={column}>
        <JoditEditor
          ref={editorRef}
          value={fields[column] || ""}
          config={editorConfig}
          onChange={(value) => {
            // Keep latest HTML without waiting for blur (Save can fire first).
            latestValueRef.current = value ?? "";
          }}
          onBlur={(value) => commitValue(value)}
        />
      </div>

      {errors[column] && <div className="text-danger">{errors[column]}</div>}
    </>
  );
};

export const InputFile = ({fields, setFields, column, label = null, required = false, errors = {}, disabled=false}) => {

  if (required && fields[column]) {
    required = false;
  }

  return <div>
          <label htmlFor={column} className="form-label">{label}
            {required ? <span className="text-danger"> *</span> : ''}
          </label>
            
          <input type="file" className="form-control" id={column} placeholder={label}
            required={required} disabled={disabled} onChange={(e) => setFields((prev) => ({ ...prev, [column]: e.target.files[0] }))} />
          
          {fields[column] && fields[column + '_file'] &&
            <div className="mt-2">
              <a href={process.env.REACT_APP_ASSETS_URL + '/' + fields[column + '_path']} target="_blank" className="text-primary">{fields[column + '_file']}</a>
              &nbsp;&nbsp;
              <a href="#" onClick={(e) => {
                  e.preventDefault();
                  setFields((prev) => ({ ...prev, [column]: '' }));
                }}>
                  <i className="bi bi-x-lg text-danger" style={{fontSize: '14px'}}></i>
              </a>
            </div>
          }

          {errors[column] && <div className="text-danger">{errors[column]}</div>}
      </div>
}
